export enum ProductTypeEnum{
    SINGLE = 'SINGLE',
    COMBO = 'COMBO'
} 